import {Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Theme} from '../../../../types/admin-data.types';
import {NgForm} from '@angular/forms';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {environment} from '../../../../../environments/environment';
import {ConstantsService} from '../../../../services/constants.service';
import {ApiClientService} from '../../../../services/api-client.service';
import {UrlService} from '../../../../services/url.service';
import {AuthTokenService} from '../../../../services/auth-token.service';
import {PropertyService} from '../services/property.service';

declare const $;
declare const swal;
declare const toastr;

@Component({
    selector: 'custom-theme-modal',
    templateUrl: 'custom-theme-modal.component.html',
    styleUrls: ['custom-theme-modal.component.scss'],
})
export class CustomThemeModalComponent implements OnInit, OnDestroy {
    @ViewChild('form') form;
    data: Theme = new Theme();
    showModal = true;
    disabledSubmit = false;
    disabledFileInput = false;
    spinnerShow = {
        logo: false,
        miniLogo: false
    };
    private customThemesSubscriber;

    constructor(
        private api: ApiClientService,
        private http: Http,
        private urlService: UrlService,
        private authTokenService: AuthTokenService,
        private propertyService: PropertyService,
    ) {
    }

    ngOnInit(): void {
        this.customThemesSubscriber = this.propertyService.customThemes$.subscribe((customThemes: Theme[])=>{
            if (this.propertyService.selectedBuilding) {
                const theme = customThemes.find(theme => +theme.buildingId === +this.propertyService.selectedBuilding.id);
                if (theme) {
                    this.data = JSON.parse(JSON.stringify(theme));
                }
            }
            this.initColorPickers();

        })

        this.urlService.modalOpened.emit();
    }

    hideModal() {
        if (this.form.dirty) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                (event) => {
                    if (event) {
                        this.propertyService.customThemeModalShow = false;
                        this.urlService.modalClosed.emit();
                    }
                }
            );
        } else {
            this.propertyService.customThemeModalShow = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!this.propertyService.selectedBuilding) {
            toastr.warning('Building not be blank.');
            return;
        }
        if (!form.value.name) {
            toastr.warning('Name should not be blank.');
            return;
        }
        if (!this.data.logo) {
            toastr.warning('Logo should not be blank.');
            return;
        }

        const data: Partial<Theme> = {
            name: form.value.name,
            logo: this.data.logo,
            settings: this.getSettingsFromForm()
        };

        this.disabledSubmit = true;

        if (this.data.id) {
            this.propertyService.updateCustomTheme(this.data.id, data).subscribe(res => {
                console.log(res);
                this.updateView('Theme successfully updated');
            }, error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Edit theme failed');
            })
        } else {
            data.buildingId = +this.propertyService.selectedBuilding.id;
            data.corporationNumberId = +this.propertyService.selectedBuilding.corporationNumber;
            data.company = +this.propertyService.selectedBuilding.companyId;

            this.propertyService.createCustomTheme(data).subscribe(res => {
                this.updateView('Theme successfully created');
            }, error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Create theme failed');
            })
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.propertyService.getListCustomThemes();
        this.form.reset();
        this.hideModal();
    }

    initColorPickers() {
        $('#body-bg').spectrum({
            color: this.data.colors.body,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.body = color.toHexString()
        });

        $('#primary-color').spectrum({
            color: this.data.colors.primary,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.primary = color.toHexString()
        });

        $('#primary-hover-color').spectrum({
            color: this.data.colors.primaryHover,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.primaryHover = color.toHexString()
        });

        $('#secondary-color').spectrum({
            color: this.data.colors.secondary,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.secondary = color.toHexString()
        });

        $('#menu-background-color').spectrum({
            color: this.data.colors.menuBackgroundColor,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.menuBackgroundColor = color.toHexString()
        });

        $('#menu-font-color').spectrum({
            color: this.data.colors.menuFontColor,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.menuFontColor = color.toHexString()
        });

        $('#selected-menu-item-font-color').spectrum({
            color: this.data.colors.selectedMenuItemFontColor,
            showInput: true,
            showButtons: false,
            containerClassName: 'custom-colorpicker',
            preferredFormat: 'rgb',
            change: (color) => this.data.colors.selectedMenuItemFontColor = color.toHexString()
        });
    }

    changeLogo(e, target: string) {
        if (this.disabledFileInput) return;
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.spinnerShow[target] = true;
        this.disabledFileInput = true;
        this.http.post(`${environment.domainEmails}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('File path should not be blank.');
                    return;
                }
                this.data[target] = res.path;
                this.spinnerShow[target] = false;
                this.disabledFileInput = false;
            },
            error => {
                this.api.errorHandler(error, 'Upload file failed');
                this.spinnerShow[target] = false;
                this.disabledFileInput = false;
            }
        );
    }

    removeLogo(e, target: string) {
        e.preventDefault();
        swal(ConstantsService.getSwalConfig('Remove Logo?', 'You want to delete Logo?'),
            () => {
                this.data[target] = '';
            }
        );
    }

    getSettingsFromForm() {
        const obj = {
            colors: {
                body: this.data.colors.body,
                primary: this.data.colors.primary,
                primaryHover: this.data.colors.primaryHover,
                secondary: this.data.colors.secondary,
                menuBackgroundColor: this.data.colors.menuBackgroundColor,
                menuFontColor: this.data.colors.menuFontColor,
                selectedMenuItemFontColor: this.data.colors.selectedMenuItemFontColor
            },
            miniLogo: this.data.miniLogo
        };

        return JSON.stringify(obj);
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }

    ngOnDestroy(): void {
        if (this.customThemesSubscriber) {
            this.customThemesSubscriber.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/custom-theme-modal/custom-theme-modal.component.ts